import React from 'react';

interface Props {
  text: string;
}

export default function PageSubHeading({ text }: Props) {
  return <p className='~text-sm/xl'>{text}</p>;
}
